// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import FloatingContact, { FloatingContactProvider } from './components/FloatingContact';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import BlogPage from './pages/BlogPage';
import BlogPost from './pages/BlogPost';
import DownloadsPage from './pages/DownloadsPage';
import StartNowPage from './pages/StartNowPage';
import CollaborationPage from './pages/CollaborationPage';
import ServiceFormPage from './pages/ServiceFormPage';
import ScrollToHashElement from './components/ScrollToHashElement';
import ScrollToTop from './components/ScrollToTop';
import './styles/variables.css';
import './App.css';

function App() {
  return (
    <Router>
      <FloatingContactProvider>
        <div className="app">
          <ScrollToHashElement />
          <ScrollToTop />
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/blog" element={<BlogPage />} />
              <Route path="/blog/:postId" element={<BlogPost />} />
              <Route path="/start-now" element={<StartNowPage />} />
              <Route path="/collaboration" element={<CollaborationPage />} />
              <Route path="/service-form/:service" element={<ServiceFormPage />} />
              <Route path="/service-form" element={<ServiceFormPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </FloatingContactProvider>
    </Router>
  );
}

export default App;
